import React from 'react';
import { AccountPanelTypes } from '../../AccountPanelTypes';
import { Icon } from '../../../../utilities/icomoon-css';

export const ErrorLabel = ({ message }: AccountPanelTypes.TErrorLabel) => {
  return (
    <>
      {message ? (
        <div className="cardFieldsAlertMessage">
          <Icon name="tfw-danger-triangle-cp" />
          {message}
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export const getAsterisk = () => {
  return <span className="labelRequired">*</span>;
};
